export const ACCESS_TOKEN_EXPIRY_THRESHOLD = 3;

export const RESEND_OTP_TIMEOUT_SEC = 60;

export const TRUST_DEVICE_TOKEN_EXPIRES_DAYS = 14;

export const enum UserRoles {
    Admin,
    Employee
};

export const enum RoleName {
    Admin = 'Admin',
    OpsSalesAdmin = 'OpsSalesAdmin',
    ComplianceAdmin = 'ComplianceAdmin',
    FinanceAdmin = 'FinanceAdmin',
    TechAdmin = 'TechAdmin',
    Employee = 'Employee',
    Mors = 'mors',
    MorsAgent = 'MorsAgent',
    MerchantAdmin = 'MerchantAdmin',
    MerchantEmployee = 'MerchantEmployee',
    MerchantsAgent = 'MerchantsAgent',
    MerchantFinance = 'MerchantFinance',
    MerchantTech = 'MerchantTech',
    OnboardingE = 'OnboardingE',
    OnboardingO = 'OnboardingO'
};

export const enum Event {
    Redirect2FA = 'Event.Redirect2FA',
    GetUser = 'Event.GetUser'
};
